/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './folio-item-page.component.html';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {FolioModel} from './folio-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {FolioEditPageComponent} from './folio-edit-page.component';
import {FolioInformationPageComponent} from './folio-information-page.component';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED, FolioEditPageComponent, FolioInformationPageComponent],
  selector: 'adn-folio-item-page',
  template
})
export class FolioItemPageComponent {
  @Input() state: SignalAdminResourcePageState<FolioModel>;
}
